import { IView } from "../Core/View";
import { ViewFactory } from "../Core/Factories/ViewFactory";

import { ItemView } from "./Shop/ItemView";
import { CartView } from "./Shop/CartView";
import { IndexView } from "./Shop/IndexView";

ViewFactory.setRegistry({
    'ItemView': ItemView,
    'CartView': CartView,
    'IndexView': IndexView,
});


// WEBPACK FOOTER //
// ./www/js/Pages/Shop.ts